// extracted by mini-css-extract-plugin
export var container = "_f0-1";
export var cornerButtonContainer = "_f0-6";
export var disabled = "_f0-2";
export var dragActive = "_f0-3";
export var fileContainer = "_f0-5";
export var hiddenInput = "_f0-4";
export var widthContainer = "_f0-0";